import { useEffect } from 'react';

export const useResetScrollOnMount = () => {
  const supportsSmooth = 'scrollBehavior' in document.documentElement.style;

  const scrollTopSmooth = () => {
    window.scrollTo({
      top: 0,
      behavior: supportsSmooth ? 'smooth' : 'auto',
    });
  };

  useEffect(() => {
    const voWifiContainer = document.querySelector(
      '.c-VoWifi',
    ) as HTMLElement | null;

    // Ensure we are in a real browser environment (prevents crashes in SSR like Next.js)
    if (typeof window === 'undefined') return;

    try {
      if (voWifiContainer) {
        voWifiContainer.scrollTop = 0;
        scrollTopSmooth();
      } else {
        scrollTopSmooth();
      }
    } catch {
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch {
        // Silent fail
      }
    }
  }, []);
};
